import { usePermissionsContext } from "./permissions-provider";

/**
 * Returns true if the current user has the given permission, false otherwise.
 *
 * Permission key format on the backend: "<application>:<feature>:<category>".
 *
 * Example:
 *   const canEditChannels = usePermission("host-console", "channels", "Write");
 *   if (canEditChannels) { ... }
 */
export function usePermission(
  application: string,
  feature: string,
  category: string,
): boolean {
  const { has } = usePermissionsContext();
  return has(application, feature, category);
}

export function useAttributePermission(
  application: string,
  feature: string,
  attribute: string,
): boolean {
  const { hasAttribute } = usePermissionsContext();
  return hasAttribute(application, feature, attribute);
}
